<template>
  <div class="contacts-page row">
    <div class="left-wrap medium-12">
      <survey-header
        :header-title="pageTitle"
        :button-text="$t('SURVEY_MGMT.SURVEY.HEADER_BTN_TXT')"
        @open-add-modal="openAddModel"
      />
      <ve-table
        :fixed-header="true"
        max-height="calc(100vh - 11.4rem)"
        scroll-width="187rem"
        :columns="columns"
        :table-data="getSurveys"
        :border-around="false"
        row-key-field-name="id"
      />
      <woot-modal
        v-if="!enableSmartSurveys"
        :show.sync="showAddModel"
        :on-close="closeAddModel"
        size="medium"
      >
        <woot-modal-header>
          <h5>
            {{ $t('SURVEY_MGMT.MODELS.MODAL.DISABLED') }}
          </h5>
        </woot-modal-header>
        <div class="warning-container">
          <p v-html="$t('SURVEY_MGMT.MODELS.MODAL.DISABLED_DESCRIPTION')" />
          <a
            class="btn-primary"
            href="http://wa.me/553198795790"
            target="_blank"
          >
            {{ $t('SURVEY_MGMT.MODELS.MODAL.CLICK_HERE') }}
          </a>
        </div>
      </woot-modal>
      <div v-if="enableSmartSurveys">
        <woot-modal
          :show.sync="showAddModel"
          :on-close="closeAddModel"
          size="medium"
        >
          <blank-survey v-if="!selectedModel" @on-close="closeAddModel" />
        </woot-modal>
        <woot-modal
          :show.sync="showSendModal"
          :on-close="closeSendModal"
          size="medium"
        >
          <send-survey
            :survey="selectedSurvey"
            :send-type="sendType"
            @on-close="closeSendModal"
          />
        </woot-modal>
        <woot-modal
          :show.sync="showEmbedModal"
          :on-close="closeEmbedModal"
          size="medium"
        >
          <woot-modal-header :header-title="'Configurar embed da pesquisa'" />
          <div class="embed-settings">
            <div class="medium-12 columns">
              <label class="radio-group-label">Formato de exibição</label>
              <div class="layout-option-group">
                <label
                  v-for="option in layoutOptions"
                  :key="option.value"
                  class="layout-option"
                  :class="{ 'layout-option--active': embedSettings.layout === option.value }"
                >
                  <input
                    v-model="embedSettings.layout"
                    class="radio-input"
                    type="radio"
                    :value="option.value"
                  />
                  <span class="layout-option__title">{{ option.title }}</span>
                  <span class="layout-option__description">{{ option.description }}</span>
                </label>
              </div>
            </div>
            <woot-input
              v-model.trim="embedSettings.launcher_title"
              label="Texto do botão"
              placeholder="Pesquisa"
              class="medium-12 columns"
            />
            <label class="medium-12 columns">
              Cor do botão
              <woot-color-picker v-model="embedSettings.color" />
            </label>
            <div
              v-if="!['modal', 'footer'].includes(embedSettings.layout)"
              class="medium-12 columns"
            >
              <label class="radio-group-label">Posição</label>
              <div class="radio-group">
                <label class="radio-group-item-label">
                  <input
                    v-model="embedSettings.position"
                    class="radio-input"
                    type="radio"
                    value="right"
                  />
                  <span>Direita</span>
                </label>
                <label class="radio-group-item-label">
                  <input
                    v-model="embedSettings.position"
                    class="radio-input"
                    type="radio"
                    value="left"
                  />
                  <span>Esquerda</span>
                </label>
              </div>
            </div>
            <div class="medium-12 columns">
              <woot-button
                class="bg-primary"
                :is-loading="loading"
                @click="generateEmbedScript"
              >
                Gerar código
              </woot-button>
            </div>
            <div v-if="embedScript" class="medium-12 columns">
              <woot-code :script="embedScript" lang="html" />
            </div>
          </div>
        </woot-modal>
        <woot-modal
          :show.sync="showDeleteModal"
          :on-close="closeDeleteModal"
          size="medium"
        >
          <woot-confirm-delete-modal
            v-if="showDeleteModal"
            :show.sync="showDeleteModal"
            :title="$t('SURVEY_MGMT.MODELS.DELETE.TITLE')"
            :message="$t('SURVEY_MGMT.MODELS.DELETE.MESSAGE')"
            :confirm-text="$t('SURVEY_MGMT.MODELS.DELETE.CONFIRM_TEXT')"
            reject-text="Cancelar"
            :confirm-value="$t('SURVEY_MGMT.MODELS.DELETE.CONFIRM_VALUE')"
            :confirm-place-holder-text="
              $t('SURVEY_MGMT.MODELS.DELETE.PLACEHOLDER')
            "
            @on-confirm="confirmSurveyDelete"
            @on-close="closeDeleteModal"
          />
        </woot-modal>
        <woot-modal
          :show.sync="showCampaignModal"
          :on-close="closeCampaignModal"
          size="medium"
        >
          <add-campaign
            :default-message="surveyMessage"
            campaign-force-type="one_off"
            @on-close="closeCampaignModal"
          />
        </woot-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { VeTable } from 'vue-easytable';
import SurveyHeader from './Header';
import alertMixin from 'shared/mixins/alertMixin';
import BlankSurvey from './BlankSurvey.vue';
import SendSurvey from './SendSurvey.vue';
import getUuid from '../../../../../widget/helpers/completeUuid';
import AddCampaign from '../../settings/campaigns/AddCampaign.vue';

export default {
  components: {
    SurveyHeader,
    BlankSurvey,
    VeTable,
    SendSurvey,
    AddCampaign,
  },
  mixins: [alertMixin],

  data() {
    return {
      averageCellWidth: 15,
      intCellWidth: 5,
      kanbanId: 0,
      showAddModel: false,
      loading: false,
      kanbanMeta: {},
      heading: 'Teste',
      content: 'content',
      src: 'src',
      buttonText: 'Selecionar Modelo',
      selectedModel: null,
      selectedSurvey: null,
      showDeleteModal: false,
      showCampaignModal: false,
      showSendModal: false,
      sendType: 'email',
      surveyMessage: '',
      showEmbedModal: false,
      selectedEmbedSurvey: null,
      embedScript: '',
      embedSettings: {
        layout: 'slide',
        position: 'right',
        color: '#1f93ff',
        launcher_title: 'Pesquisa',
      },
      layoutOptions: [
        {
          value: 'slide',
          title: 'Slide-in',
          description: 'Desliza do canto inferior, menos invasivo.',
        },
        {
          value: 'modal',
          title: 'Modal/Popup',
          description: 'Aparece centralizado sobre o site com fundo escurecido.',
        },
        {
          value: 'tab',
          title: 'Aba Lateral',
          description: 'Aba fixa na lateral, sempre visível, expande ao clicar.',
        },
        {
          value: 'footer',
          title: 'Footer Bar',
          description: 'Barra fixa no rodapé, expande para cima ao clicar.',
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      accountId: 'getCurrentAccountId',
      kanbanList: 'getKanbanfunnels',
      currentAccountId: 'getCurrentAccountId',
      getAccount: 'accounts/getAccount',
      getSurveys: 'customSurveys/getAllSurveys',
    }),
    columns() {
      return [
        {
          field: 'name',
          key: 'name',
          title: this.$t('SURVEY_MGMT.SURVEY.TABLE.NAME'),
          display: 'flex',
          property: 'name',
          rowKey: ({ row }) => row.id,
          width: this.averageCellWidth,
          renderBodyCell: ({ row }) => (
            <div class="text-truncate user-email-white">{row.name}</div>
          ),
        },
        {
          field: 'description',
          key: 'description',
          title: this.$t('SURVEY_MGMT.SURVEY.TABLE.DESCRIPTION'),
          rowKey: ({ row }) => row.id,
          width: this.averageCellWidth,
          renderBodyCell: ({ row }) => {
            if (row.description)
              return (
                <div class="text-truncate user-email-white">
                  {row.description}
                </div>
              );
            return '---';
          },
        },
        {
          field: 'responses',
          key: 'responses',
          title: this.$t('SURVEY_MGMT.SURVEY.TABLE.RESPONSES'),
          rowKey: ({ row }) => row.id,
          width: this.intCellWidth,
          renderBodyCell: ({ row }) => {
            if (row.responses)
              return (
                <div class="text-truncate user-email-white">
                  {row.responses.length}
                </div>
              );
            return '0';
          },
        },
        {
          field: 'average',
          key: 'average',
          title: this.$t('SURVEY_MGMT.SURVEY.TABLE.AVERAGE'),
          rowKey: ({ row }) => row.id,
          width: this.intCellWidth,
          renderBodyCell: ({ row }) => {
            if (row.responses) {
              const averageRating = row.responses.reduce(
                (acc, response) => {
                  const ratingA = response.questions.find(
                    q => q.type === 'rating_a'
                  );

                  const rating =
                    !ratingA &&
                    response.questions.find(
                      q => q.type === 'rating' && q.required === true
                    );

                  let validRating = null;
                  if (ratingA) {
                    validRating = ratingA.response;
                  } else if (rating) {
                    validRating = rating.response;
                  }

                  if (validRating !== null) {
                    acc.sum += validRating;
                    acc.count += 1;
                  }

                  return acc;
                },
                { sum: 0, count: 0 }
              );

              const average =
                averageRating.count > 0
                  ? (averageRating.sum / averageRating.count).toFixed(2)
                  : '0';

              return (
                <div class="text-truncate user-email-white">{average}</div>
              );
            }

            return '0';
          },
        },
        {
          field: 'promoters',
          key: 'promoters',
          title: this.$t('SURVEY_MGMT.SURVEY.TABLE.PROMOTER'),
          rowKey: ({ row }) => row.id,
          width: this.intCellWidth,
          renderBodyCell: ({ row }) => {
            if (row.responses) {
              const validRatingsCount = row.responses.reduce(
                (count, response) => {
                  const ratingA = response.questions.find(
                    q =>
                      q.type === 'rating_a' &&
                      (q.response === 9 || q.response === 10)
                  );

                  const rating =
                    !ratingA &&
                    response.questions.find(
                      q =>
                        q.type === 'rating' &&
                        q.required === true &&
                        (q.response === 4 || q.response === 5)
                    );
                  return count + (ratingA || rating ? 1 : 0);
                },
                0
              );

              return (
                <div class="text-truncate user-email-white">
                  {validRatingsCount}
                </div>
              );
            }

            return '0';
          },
        },
        {
          field: 'neutre',
          key: 'neutre',
          title: this.$t('SURVEY_MGMT.SURVEY.TABLE.NEUTRE'),
          rowKey: ({ row }) => row.id,
          width: this.intCellWidth,
          renderBodyCell: ({ row }) => {
            if (row.responses) {
              const validRatingsCount = row.responses.reduce(
                (count, response) => {
                  const ratingA = response.questions.find(
                    q =>
                      q.type === 'rating_a' &&
                      (q.response === 7 || q.response === 8)
                  );

                  const rating =
                    !ratingA &&
                    response.questions.find(
                      q =>
                        q.type === 'rating' &&
                        q.required === true &&
                        q.response === 3
                    );

                  return count + (ratingA || rating ? 1 : 0);
                },
                0
              );

              return (
                <div class="text-truncate user-email-white">
                  {validRatingsCount}
                </div>
              );
            }

            return '0';
          },
        },
        {
          field: 'detrator',
          key: 'detrator',
          title: this.$t('SURVEY_MGMT.SURVEY.TABLE.DETRACTOR'),
          rowKey: ({ row }) => row.id,
          width: this.intCellWidth,
          renderBodyCell: ({ row }) => {
            if (row.responses) {
              const validRatingsCount = row.responses.reduce(
                (count, response) => {
                  const ratingA = response.questions.find(
                    q => q.type === 'rating_a' && q.response < 7
                  );

                  const rating =
                    !ratingA &&
                    response.questions.find(
                      q =>
                        q.type === 'rating' &&
                        q.required === true &&
                        (q.response === 1 || q.response === 2)
                    );

                  return count + (ratingA || rating ? 1 : 0);
                },
                0
              );

              return (
                <div class="text-truncate user-email-white">
                  {validRatingsCount}
                </div>
              );
            }

            return '0';
          },
        },
        {
          field: 'actions',
          key: 'actions',
          title: this.$t('SURVEY_MGMT.SURVEY.TABLE.ACTIONS'),
          width: 6,
          align: 'center',
          renderBodyCell: ({ row }) => (
            <div>
              <div class="actions-grid">
                <woot-button
                  onClick={event => {
                    event.stopPropagation();
                    this.getUrl(row);
                  }}
                  class="new-message bg-primary"
                  icon="clipboard"
                  size="small"
                  v-tooltip={`${this.$t(
                    'SURVEY_MGMT.SURVEY.TABLE.BUTTONS.COPY'
                  )}`}
                  variant="smooth"
                />
                <woot-button
                  onClick={event => {
                    event.stopPropagation();
                    this.openEmbedModal(row);
                  }}
                  class="new-message bg-primary"
                  icon="code"
                  size="small"
                  v-tooltip="Embed"
                  variant="smooth"
                />
                <router-link
                  to={`/app/accounts/${this.$route.params.accountId}/survey/${row.uuid}`}
                >
                  <woot-button
                    class="new-message bg-primary"
                    icon="eye-show"
                    size="small"
                    v-tooltip={`${this.$t(
                      'SURVEY_MGMT.SURVEY.TABLE.BUTTONS.VIEW'
                    )}`}
                    variant="smooth"
                  />
                </router-link>
                <woot-button
                  onClick={event => {
                    event.stopPropagation();
                    this.openSendModal(row, 'whatsapp');
                  }}
                  class="new-message bg-primary"
                  icon="send"
                  size="small"
                  v-tooltip={`${this.$t(
                    'SURVEY_MGMT.SURVEY.TABLE.BUTTONS.SEND'
                  )}`}
                  variant="smooth"
                />
                <woot-button
                  onClick={event => {
                    event.stopPropagation();
                    this.openCampaignModal(row);
                  }}
                  class="new-message bg-primary"
                  icon="people"
                  size="small"
                  v-tooltip={`${this.$t(
                    'SURVEY_MGMT.SURVEY.TABLE.BUTTONS.SEND_CAMPAIGN'
                  )}`}
                  variant="smooth"
                />
                <woot-button
                  onClick={event => {
                    event.stopPropagation();
                    this.openDeleteModal(row);
                  }}
                  class="new-message bg-primary"
                  icon="delete"
                  size="small"
                  v-tooltip={`${this.$t(
                    'SURVEY_MGMT.SURVEY.TABLE.BUTTONS.DELETE'
                  )}`}
                  variant="smooth"
                  color-scheme="alert"
                />
              </div>
            </div>
          ),
        },
      ];
    },
    pageTitle() {
      return this.$t('SURVEY_MGMT.SURVEY.HEADER');
    },
    enableSmartSurveys() {
      const account = this.getAccount(this.currentAccountId);
      return account?.enable_smart_surveys;
    },
  },

  watch: {},
  mounted() {
    this.$store.dispatch('customSurveys/getSurvey');
    this.$store.dispatch('agents/get');
  },
  methods: {
    getUrl(survey) {
      const baseUrl = window.location.origin;
      const url = `${baseUrl}/survey/custom_surveys/${getUuid()}&${
        survey.uuid
      }`;

      window.open(url);

      return url;
    },
    getAllUrl(survey) {
      const baseUrl = window.location.origin;
      const url = `${baseUrl}/survey/custom_surveys/&${survey.uuid}`;

      return url;
    },
    openDeleteModal(survey) {
      this.selectedSurvey = survey;
      this.showDeleteModal = true;
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
    },
    openCampaignModal(survey) {
      this.surveyMessage = this.getAllUrl(survey);
      this.showCampaignModal = true;
    },
    closeCampaignModal() {
      this.showCampaignModal = false;
    },

    confirmSurveyDelete() {
      this.deleteSurvey(this.selectedSurvey.id);
      this.selectedSurvey = null;
      this.closeDeleteModal();
    },

    deleteSurvey(id) {
      this.$store
        .dispatch('customSurveys/deleteSurvey', { id })
        .then(() => {
          this.showAlert(this.$t('SURVEY_MGMT.SURVEY.DELETE.SUCCESS_MESSAGE'));
        })
        .catch(error => {
          const errorMessage =
            error?.response?.message ||
            this.$t('SURVEY_MGMT.SURVEY.DELETE.ERROR_MESSAGE');
          // eslint-disable-next-line no-console
          console.error(error);
          this.showAlert(errorMessage);
        });
    },

    openSendModal(survey, type) {
      this.selectedSurvey = survey;
      this.sendType = type;
      this.showSendModal = true;
    },
    closeSendModal() {
      this.showSendModal = false;
    },
    openEmbedModal(survey) {
      this.selectedEmbedSurvey = survey;
      this.embedScript = '';
      this.showEmbedModal = true;
    },
    closeEmbedModal() {
      this.showEmbedModal = false;
      this.selectedEmbedSurvey = null;
      this.embedScript = '';
    },
    async generateEmbedScript() {
      if (!this.selectedEmbedSurvey) return;
      try {
        this.loading = true;
        const script = await this.$store.dispatch('customSurveys/getEmbedScript', {
          id: this.selectedEmbedSurvey.uuid,
          settings: this.embedSettings,
        });
        this.embedScript = script;
      } catch (error) {
        this.showAlert('Erro ao gerar script de embed');
      } finally {
        this.loading = false;
      }
    },
    openAddModel() {
      this.selectedModel = null;
      this.showAddModel = true;
    },
    closeAddModel() {
      this.showAddModel = false;
    },
    openEditModel(model) {
      this.selectedModel = model;
      this.showAddModel = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.contacts-page {
  width: 100%;
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 30px;
}

.loading {
  text-align: center;
}

.left-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.actions-grid {
  // display: grid;
  // grid-template-columns: repeat(2, 1fr);
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-self: center;
}
.actions-grid .woot-button {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-container {
  display: none;
}
.warning-container {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  padding: 0 0 15px 0;
  gap: 6px;
}
.modal-container p {
  font-size: 1.4rem;
  margin: 10px 0px 0px 25px;
  padding: 0;
}
.embed-settings {
  padding: 1rem;
}
.embed-settings .columns {
  margin-bottom: 1rem;
}
.layout-option-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
  margin-top: 0.5rem;
}
.layout-option {
  border: 1px solid var(--b-300, #dadde1);
  border-radius: 8px;
  padding: 0.75rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.layout-option:hover {
  border-color: var(--w-500, #1f93ff);
}
.layout-option--active {
  border-color: var(--w-500, #1f93ff);
  background: var(--w-50, #f0f8ff);
}
.layout-option .radio-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.layout-option__title {
  font-weight: 600;
  font-size: 0.875rem;
}
.layout-option__description {
  font-size: 0.75rem;
  color: var(--s-500, #6b7280);
}
</style>
